export interface ISetting {
  alias: string;
  value: string;
}

export type IAutorunApplication = {
  path: string;
  args: string;
  kill_on_seance: boolean;
  runas: boolean;
  run_hidden: boolean;
};

export enum Tax {
  NONE = 'NONE',
  VAT0 = 'VAT0',
  VAT7 = 'VAT5',
  VAT5 = 'VAT7',
  VAT10 = 'VAT10',
  VAT20 = 'VAT20',
  VAT110 = 'VAT110',
  VAT120 = 'VAT120',
}

export interface ITelegramChannelId {
  id: string;
  type: ETelegramChannelType;
  title: string;
}

export enum ETelegramChannelType {
  SUPERGROUP = 'SUPERGROUP',
  GROUP = 'GROUP',
  CHANNEL = 'CHANNEL',
  PRIVATE = 'PRIVATE',
}
